import { createRoutine } from 'redux-saga-routines';

export const chatRoutine = createRoutine("API_CHAT_GET");
export const chatSendRoutine = createRoutine("API_CHAT_SEND");
export const chatReadRoutine = createRoutine("API_CHAT_READ");
